import { object, ref, string } from 'yup';
// const nameRegex = /^[a-zA-Z\u0600-\u06FF\s]+$/;

export const securityValidation = (
  t,
  isName,
  isEmail,
  isPhone,
  isPassword,
  isOldUserPassword,
  otpSent
) =>
  object().shape({
    firstName: isName ? string().required(t('common.FirstNameRequired')) : null,
    email: isEmail
      ? string()
          .matches(
            /^(5\d{8}|[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/,
            t('common.emailError')
          )
          .required(t('common.emailMobileRequired'))
      : null,
    phone: isPhone
      ? string()
          .label('Phone number')
          .matches(/^(?!.*[\u0660-\u0669])[0-9]+$/, t('common.telephoneError1'))
          .matches(/^5[0-9]{8}$/, t('telephoneError2'))
          .min(9)
          .required(t('common.TelephoneRequired'))
      : null,
    otp:
      otpSent || isOldUserPassword
        ? string()
            .length(4, t('common.OTPInvalidLength')) // Ensures OTP is exactly 4 digits
            .matches(/^\d{4}$/, t('common.OTPInvalid')) // Ensures OTP contains only numbers
            .required(t('common.OTPRequired'))
        : null,
    currentPassword:
      isName || isEmail || isPassword || isPhone
        ? string().required(t('common.PasswordRequired'))
        : null,
    password:
      isPassword || isOldUserPassword
        ? string()
            .min(8, t('common.HasAtLeast8Characters'))
            .matches(/[A-Z]/, t('common.ContainsOneUppercaseLetter'))
            .matches(/[a-z]/, t('common.ContainsOneLowercaseLetter'))
            .matches(/[0-9]/, t('common.ContainsOneNumber'))
            .required(t('common.PasswordRequired'))
        : null,
    confirmPassword: isPassword
      ? string()
          .oneOf([ref('password'), null], t('common.PasswordsMustMatch'))
          .required(t('common.ConfirmPasswordRequired'))
      : null,
  });

export const addressValidation = (t) =>
  object().shape({
    firstName: string().required(t('common.FirstNameRequired')),
    phone: string()
      .label('Phone number')
      .matches(/^(?!.*[\u0660-\u0669])[0-9]+$/, t('common.telephoneError1'))
      .matches(/^5[0-9]{8}$/, t('telephoneError2'))
      .min(9)
      .required(t('common.TelephoneRequired')),

    email: string()
      .email(t('common.invalidEmail'))
      .required(t('common.emailRequired')),
    type: string().required(t('common.TypeRequired')),
    city: string().required(t('common.CityRequired')),
    district: string().required(t('common.DistrictRequired')),
    region: string().required(t('common.RegionRequired')),
    shortAddress: string().required(t('common.ShortAddressRequired')),
    address: string().min(10).required(t('common.AddressRequired')),
  });
export const rateProductValidation = (t) =>
  object().shape({
    message: string().required(t('common.RateMessageRequired')),
  });

export const addressV2Validation = (t, mode) =>
  object().shape({
    name: string()
      .required(t('required_key'))
      .min(2, t('min_two_words_key', { count: 2 }))
      .test('full-name', t('min_two_words_key'), (value) => {
        if (!value) return false;
        const parts = value?.trim()?.split(' ');
        return parts.length >= 2 && parts.every((part) => part.length >= 2);
      }),
    ...(mode === 'national'
      ? { nationalAddress: string().required(t('required_key')) }
      : {}),
    ...(mode !== 'auto'
      ? {
          city: string().required(t('required_key')),
          // region: string()
          //   .required(t('required_key'))
          //   .test('region-required', t('required_key'), function (value) {
          //     const { city } = this.parent;
          //     if (!city) return true;
          //     return !!value;
          //   }),
          address: string().required(t('required_key')).min(10, t('min_key')),
        }
      : {}),
    phone: string()
      .required(t('required_key'))
      .matches(/^5\d{8}$/, t('invalid_phone_key')),
    email: string().email(t('invalid_email_key')).required(t('required_key')),
    deliveryInstrucation: string().required(t('required_key')),
  });

export const addEditAddressValidation = (t) =>
  object().shape({
    region_id: string().required(t('common.RegionRequired')),
    // city_id: string().required(t('common.DistrictRequired')),
    street: string().required(t('common.streetRequired')),
  });
